export const getPrimaryCartQueryVariables = (ids: string[]) => ({
	filter: {
		product: {
			id: {
				_in: ids,
			},
		},
	},
	genericFilter: {
		product: {
			id: {
				_in: ids,
			},
		},
	},
});
